import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: '12px !important',    
  }
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const classes = useStyles();
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [fullName, setFullName] = React.useState("");
  const [emailId, setEmailId] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [userType, setUserType] = React.useState("User");
  const [roleId, setRoleId] = React.useState("noselect");
  const [roleName, setRoleName] = React.useState("");
  const [status, setStatus] = React.useState("Active");
  


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  function handleRole(rid){ 
    if(rid>0 && props.roles.length>0){
      for(let i=0; i<props.roles.length; i++){
        if(props.roles[i].autoId===rid){
          setRoleId(props.roles[i].autoId);
          setRoleName(props.roles[i].roleName);
        }
      }
    }
  }

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  React.useEffect(() => {	
    if(props.dataObj && props.dataObj.autoId>0){	
      setFullName(props.dataObj.fullName);
      setEmailId(props.dataObj.emailId);
      setUserType(props.dataObj.userType);
      setRoleId(props.dataObj.roleId);
      setRoleName(props.dataObj.roleName);
      setStatus(props.dataObj.status);
    }else{
      setFullName("");
      setEmailId("");
      setUserType("User");
      setRoleId("noselect");
      setRoleName("");
      setStatus("Active");
    
    }
	}, [props.dataObj]);


	function saveData(){
    if(!fullName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter full name");			
      return false;
    }
    if(!emailId){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Email can not be empty.");	
      return false;
    }
    if(emailId && emailId.length>0 && !validateEmail(emailId) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Email is not valid.");			
      return false;
    }
    if(!props.dataObj && !newPassword){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Password can not be empty.");			
      return false;
    }
    if(userType==="User" && roleId==="noselect"){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select role");			
      return false;
    }

		if(emailId && fullName){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
          'token': userObj.token,
          'loginEmailId': userObj.emailId,
				}
			}; 
    
      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId>0){
        data.append('id', props.dataObj.autoId);
        if(props.dataObj.currentRoleId){
          data.append('currentRoleId', props.dataObj.currentRoleId);
        }
      }
      data.append('fullName', fullName);
      data.append('emailId', emailId);

      if(roleId && roleId>0){
        data.append('roleId', roleId);
        data.append('roleName', roleName);
      }

      if(newPassword && newPassword.length>0){
        data.append('password', newPassword);
      }

      if(userType==="Admin"){
        data.append('userType', 1);
      }else{
        data.append('userType', 0);
      }    

      if(status==="Active"){
        data.append('status', 1);
      }else{
        data.append('status', 0);
      }    
             
      let apiURL='/admin-new-users';
      if(props.dataObj && props.dataObj.autoId>0){
          apiURL='/admin-update-users';
      }

			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("User details has been saved.");
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="AlreadyExistsError"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("User email-id must be unique. It is associated with another user.");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("User details could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}		
	}
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'80vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} User</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Full Name</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setFullName(event.target.value)} value={fullName} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Email Id</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setEmailId(event.target.value)} value={emailId} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>Password</td>
                          <td style={{textAlign:'center'}} >
                          <TextField type='password' onChange={event => setNewPassword(event.target.value)} value={newPassword} style={{width:'99%'}} variant="standard" />
                          </td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>User Type</td>
                            <td style={{textAlign:'center'}} >
                              <Select 
                                style={{width:'100%'}}
                                classes={{ paper: classes.paper }}
                                labelId="select-class-label"
                                id="select-class"
                                value={userType}									
                                onChange={event => setUserType(event.target.value)}
                                variant="standard"
                              >
                                  <MenuItem value="User">User</MenuItem>
                                  <MenuItem value="Admin">Admin</MenuItem>
                              </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Role</td>
                            <td style={{textAlign:'center'}} >
                                <Select 
                                style={{width:'100%'}}
                                classes={{ paper: classes.paper }}
                                labelId="select-class-label"
                                id="select-class"
                                value={roleId}									
                                onChange={event => handleRole(event.target.value)}
                                variant="standard"
                              >
                                  <MenuItem value="noselect">Select Role</MenuItem>
                                  {(props.roles && props.roles.length>0)?
                                    props.roles.map((myRow,key)=>(
                                      <MenuItem key={'rols'+key} value={myRow.autoId} >{myRow.roleName}</MenuItem> 
                                    )):null}
                              </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Status</td>
                            <td style={{textAlign:'center'}} >
                                <Select 
                                style={{width:'100%'}}
                                classes={{ paper: classes.paper }}
                                labelId="select-class-label"
                                id="select-class"
                                value={status}									
                                onChange={event => setStatus(event.target.value)}
                                variant="standard"
                              >
                                  <MenuItem value="Active">Active</MenuItem>
                                  <MenuItem value="Inactive">Inactive</MenuItem>
                              </Select>
                            </td>                            
                        </tr>
                                              
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;